import { render, staticRenderFns } from "./SupplierDetailsTabs.vue?vue&type=template&id=6aa76362&"
import script from "./SupplierDetailsTabs.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailsTabs.vue?vue&type=script&lang=js&"
import style0 from "./SupplierDetailsTabs.vue?vue&type=style&index=0&id=6aa76362&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports